"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toContainerWithLeftMenuSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toContainerWithLeftMenuSlice = function (data, logger) {
    var title = fields_1.toText(data.primary.title);
    var groups = data.items.reduce(function (acc, item) {
        var groupTitle = fields_1.toText(item.group) || types_1.LEFT_MENU_GROUP_NO_TITLE;
        var itemTitle = logger.required(fields_1.toText(item.title));
        var itemDocument = fields_1.toDocumentLink(item.document, logger);
        if (itemTitle && itemDocument) {
            var group = acc.find(function (g) { return g.title === groupTitle; });
            if (group) {
                group.items.push({
                    uid: group.title + " - " + item.title,
                    title: itemTitle,
                    document: itemDocument
                });
            }
            else {
                acc.push({
                    title: groupTitle,
                    items: [
                        {
                            uid: groupTitle + " - " + itemTitle,
                            title: itemTitle,
                            document: itemDocument
                        },
                    ]
                });
            }
        }
        return acc;
    }, []);
    if (groups.length === 0) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.ContainerWithLeftMenu)), { title: title,
        groups: groups }));
};
exports.toContainerWithLeftMenuSlice = toContainerWithLeftMenuSlice;
//# sourceMappingURL=container-with-left-menu-slice.js.map